import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'


import cors from 'cors'



Vue.use(cors);




Vue.config.productionTip = false

new Vue({
  router,
  store,

  cors,
  render: h => h(App)
}).$mount('#app')
